import { LegacyTask } from '../task/legacy-task.model';
import { ReminderTaskReminder } from 'ng2-app/modules/task-management/models/reminder-task/reminder-task-reminder.class';

export class ReminderTask extends LegacyTask {
    tasks: ReminderTaskReminder[];
}
